import {SortingModelAbstract} from "@/models/SortingModelAbstract";
import {SORT_ARGS} from "@/app/exercise/modules/payments/core/models/PlansConst";

export class PlansSortingModel extends SortingModelAbstract {
  constructor(query) {
    super(SORT_ARGS);

    this.by = [];
    this.desc = [];
    this.ordering = null;
    this._apiAttributes = {
      name: 'name',
      price: 'price',
      duration: 'duration',
      id: 'id'
    };
    this._customSorting = {};
    this._orderingFields = {
      name: 'name',
      price: 'price',
      duration: 'duration',
      id: 'id'
    };
    this._initByQuery(query);
  }
}
